/* eslint-env browser */

'use strict';

const sendPerformanceMessage = () => {
  const config = window.Groupon.Utils.getConfigFromDom();

  if (!(config && config.pageLoadData && window.BOOMR && window.BOOMR.getVar)) {
    return;
  }

  const t_resp = window.BOOMR.getVar('t_resp');
  const t_page = window.BOOMR.getVar('t_page');
  const t_done = window.BOOMR.getVar('t_done');
  const body_size = window.BOOMR.getVar('body_size');

  const { variants, deal_data, t_page_presenter, t_api } = config.pageLoadData;

  window.OptimizeSuite.TrackingHub.add('deal_page_experiment_performance', {
    deal_data,
    t_page,
    t_done,
    t_resp,
    t_page_presenter,
    t_api,
    body_size,
    variants,
  });
};

const DealPageReady = {
  init(payload, done) {
    window.Groupon.Performance.pageReady();
    sendPerformanceMessage();
    return done();
  },
};

module.exports = DealPageReady;
